module.exports = __webpack_public_path__ + "img/nocart.bbef8a39.png";